function shouldInvalidateSession(options = {}) {
  return options.ignoreAuthFailure !== true;
}

module.exports = { shouldInvalidateSession };
